module.exports = __webpack_public_path__ + "media/tikita.5facbe7c.mp3";